import gql from 'graphql-tag';
import FieldsEmployee from "graphql/fields/FieldsEmployee";
import FieldsEmployeeScans from "graphql/fields/FieldsEmployeeScans";
import FieldsUserBasic from "graphql/fields/FieldsUserBasic";
import FieldsVersion from "graphql/fields/FieldsVersion";
import FieldsEmployeeWorkdays from 'graphql/fields/FieldsEmployeeWorkdays'

export default gql(`
	query employee( $guid: String!, $scanned_in_at: String ) {
		employee( guid: $guid ) {
			${FieldsEmployee}
		    ics_url
		    next_store_review_datetime
		    bookings_may_overlap
		    enable_multi_account
			transport_kind
			vacation_mode_active
			
			department {
				guid
			}
			
			jobtitle {
				guid
			}
			
			team {
				guid
				
				building_rights {
					building {
						guid
					}
					
					floor {
						guid
					}
					
					room {
						guid
					}
				}
			}
			
			building_rights {
				building {
					guid
				}
				
				floor {
					guid
				}
				
				room {
					guid
				}
			}
			
			lunch_option {
				guid
			}
			
			language {
				guid
				code
			}
			
			versions( items_per_page: 3, page: 1 ) {
				${FieldsVersion}
			}
			
			last_version {
				${FieldsVersion}
			}
			
			scans( scanned_in_at: $scanned_in_at ) {
				${FieldsEmployeeScans}
			}
			
			user {
				${FieldsUserBasic}
			}
			
			workdays {
				${FieldsEmployeeWorkdays}
			}
			
			address {
				name
				postal_code
				locality
				country
				is_valid
			}
		}
	}
`);

